<section id="offering" class=" d-flex align-items-center offering z-depth-5 section" >
    <div class="container" data-aos="fade-up" id="grid">


          <div class="section-title">
                <h2>{{offeringHeader}}</h2>
          </div>

          <div class="row" data-aos="zoom-in" data-aos-delay="150">
                <div class="col">
                      <ul class="nav nav-tabs nav-justified md-tabs" id="myTabMD" role="tablist">
                            <li class="nav-item active">
                                  <a class="nav-link active  text-uppercase font-weight-bold text-center"
                                        id="core-tab-md" data-toggle="tab" href="#core-md" role="tab"
                                        aria-controls="core-md" aria-selected="true">Core Offerings</a>
                            </li>
                            <li class="nav-item">
                                  <a class="nav-link  text-uppercase font-weight-bold text-center"
                                        id="industry-tab-md" data-toggle="tab" href="#industry-md"
                                        role="tab" aria-controls="industry-md"
                                        aria-selected="false">Industry Offerings</a>
                            </li>

                      </ul>
                      <div class="tab-content card pt-3 z-depth-5" id="myTabContentMD">
                            <div class="tab-pane fade show active" id="core-md" role="tabpanel"
                                  aria-labelledby="core-tab-md">
                                  <div class="container ">
                                        <div class="card-block mt-4 mb-3 ">
                                              <div class="row  mb-2 ">
                                                    <div class="col-lg-2 col-md-4 "></div>
                                                    <div class="col-lg-3 col-md-4 wow d-flex align-items-stretch icon-box"
                                                    data-aos="zoom-in"  data-aos-easing="linear" data-aos-duration="200"  data-mdb-animation-on-scroll="repeat">
                                                          <a data-toggle="modal"
                                                                data-target="#scrollModal"
                                                                (click)=" getElementDetails('hana');"
                                                                id="coreOffering" data-backdrop="false">
                                                                <div
                                                                      class="card text-center rounded-top 
                                              rounded-lg border border-secondary mb-2 waves-effect z-depth-5 view overlay zoom  ">
                                                                      <div class="card-body">
                                                                            <img class="card-img-top hoverable"
                                                                                  src="./assets/Images/HomePage/s4hana.png">
                                                                      </div>
                                                                      <div
                                                                            class="mask flex-center rgba-purple-slight">
                                                                           
                                                                      </div>
                                                                      <div class="card-footer">
                                                                            <h6
                                                                                  class="font-weight-light  wow fadeInUp text-white text-uppercase">
                                                                                  SAP
                                                                                  S/4 Hana</h6>
                                                                      </div>
                                                                </div>
                                                          </a>
                                                    </div>

                                                    <div class="col-lg-2 col-md-4 "></div>

                                                    <div class="col-lg-3 col-md-4 wow fadeInUp d-flex align-items-stretch icon-box"
                                                          data-aos="zoom-in" data-aos-delay="200">
                                                          <a data-toggle="modal"
                                                                data-target="#scrollModal"
                                                                (click)=" getElementDetails('ecc');">
                                                                <div
                                                                      class="card text-center rounded-top 
                                              rounded-lg border border-secondary mb-2 waves-effect z-depth-5 view overlay zoom">
                                                                      <div class="card-body">
                                                                            <img class="card-img-top"
                                                                                  src="./assets/Images/HomePage/ecc.png">
                                                                      </div>
                                                                      <div
                                                                            class="mask flex-center rgba-purple-slight">
                                                                      </div>
                                                                      <div class="card-footer">
                                                                            <h6
                                                                                  class="font-weight-light  wow fadeInUp text-white text-uppercase">
                                                                                  SAP
                                                                                  ECC</h6>
                                                                      </div>
                                                                </div>
                                                          </a>
                                                    </div>
                                                    <div class="col-lg-1 col-md-4 "></div>

                                                   
                                                   

                                              </div>

                                              <div class="row">
                                                    <div class="col-lg-2 col-md-4"></div>
                                                    <div class="col-lg-3 col-md-4 wow fadeInUp d-flex align-items-stretch icon-box"
                                                          data-aos="zoom-in" data-aos-delay="400">
                                                          <a data-toggle="modal"
                                                                data-target="#scrollModal"
                                                                (click)=" getElementDetails('bw');">
                                                                <div
                                                                      class="card text-center rounded-top 
                                              rounded-lg border border-secondary mb-2 waves-effect z-depth-5 view overlay zoom">
                                                                      <div class="card-body">
                                                                            <img class="card-img-top"
                                                                                  src="./assets/Images/HomePage/bw.png">
                                                                      </div>
                                                                      <div
                                                                            class="mask flex-center rgba-purple-slight">
                                                                      </div>
                                                                      <div class="card-footer">
                                                                            <h6
                                                                                  class="font-weight-light  wow fadeInUp text-white text-uppercase">
                                                                                  SAP
                                                                                  BW</h6>
                                                                      </div>
                                                                </div>
                                                          </a>
                                                         
                                                    </div>
                                                    <div class="col-lg-2 col-md-4"></div>


                                                    <div class="col-lg-3 col-md-4 wow fadeInUp d-flex align-items-stretch icon-box"
                                                          data-aos="zoom-in" data-aos-delay="500">
                                                          <a data-toggle="modal"
                                                                data-target="#scrollModal"
                                                                (click)=" getElementDetails('apo');">
                                                                <div
                                                                      class="card text-center rounded-top 
                                        rounded-lg border border-secondary mb-2 waves-effect z-depth-5 view overlay zoom">
                                                                      <div class="card-body">
                                                                            <img class="card-img-top"
                                                                                  src="./assets/Images/HomePage/apo.png">
                                                                      </div>
                                                                      <div
                                                                            class="mask flex-center rgba-purple-slight">
                                                                      </div>
                                                                      <div class="card-footer">
                                                                            <h6
                                                                                  class="font-weight-light  wow fadeInUp text-white text-uppercase">
                                                                                  SAP
                                                                                  APO</h6>
                                                                      </div>
                                                                </div>
                                                          </a>
                                                        
                                                    </div>
                                                    <div class="col-lg-1 col-md-4"></div>


                                              </div>


                                        </div>
                                  </div>
                            </div>
                            <div class="tab-pane fade" id="industry-md" role="tabpanel"
                                  aria-labelledby="industry-tab-md z-depth-5">
                                  <div class="container ">
                                        <div class="card-block mt-4 mb-3">

                                              <div class="row mb-2 ">
                                                    <div class="col-lg-2 col-md-4"></div>

                                                    <div class="col-lg-4 col-md-4  wow fadeInUp d-flex align-items-stretch icon-box"
                                                          data-aos="zoom-in" data-aos-delay="200">
                                                          <a data-toggle="modal"
                                                                data-target="#scrollModal"
                                                                (click)=" getElementDetails('upstream');">
                                                                <div
                                                                      class="card text-center rounded-top 
                                        rounded-lg border border-secondary mb-2 waves-effect z-depth-5 view overlay zoom  ">
                                                                      <div class="card-body">
                                                                            <img class="card-img-top"
                                                                                  src="./assets/Images/HomePage/ecc.png">
                                                                      </div>
                                                                      <div
                                                                            class="mask flex-center rgba-purple-slight">
                                                                      </div>
                                                                      <div class="card-footer">
                                                                            <h6
                                                                                  class="font-weight-light  wow fadeInUp text-white text-uppercase">
                                                                                  IS ENERGY-UPSTREAM</h6>
                                                                      </div>
                                                                </div>
                                                          </a>
                                                    </div>
                                                    <div class="col-lg-1 col-md-4"></div>
                                                    <div class="col-lg-4 col-md-4   wow fadeInUp d-flex align-items-stretch icon-box"
                                                          data-aos="zoom-in" data-aos-delay="300">
                                                          <a data-toggle="modal"
                                                                data-target="#scrollModal"
                                                                (click)=" getElementDetails('downstream');">
                                                                <div
                                                                      class="card text-center rounded-top 
                                        rounded-lg border border-secondary mb-2 waves-effect z-depth-5 view overlay zoom">
                                                                      <div class="card-body">
                                                                            <img class="card-img-top"
                                                                                  src="./assets/Images/HomePage/ecc.png">
                                                                      </div>
                                                                      <div
                                                                            class="mask flex-center rgba-purple-slight">
                                                                      </div>
                                                                      <div class="card-footer">
                                                                            <h6
                                                                                  class="font-weight-light  wow fadeInUp text-white text-uppercase">
                                                                                  IS Energy-DOWNSTREAM</h6>
                                                                      </div>
                                                                </div>
                                                          </a>
                                                    </div>

                                                    <div class="col-lg-1 col-md-4"></div>
                                              </div>
                                              <div class="row ">
                                                    <div class="col-lg-2 col-md-4"></div>
                                                    <div class="col-lg-2 col-md-4"></div>
                                                  


                                                    <div class="col-lg-4 col-md-4 wow fadeInUp d-flex align-items-stretch icon-box"
                                                          data-aos="zoom-in" data-aos-delay="100">
                                                          <a data-toggle="modal"
                                                                data-target="#scrollModal"
                                                                (click)=" getElementDetails('utilities');">
                                                                <div
                                                                      class="card text-center rounded-top 
                                  rounded-lg border border-secondary mb-2 waves-effect z-depth-5 view overlay zoom">
                                                                      <div class="card-body">
                                                                            <img class="card-img-top"
                                                                                  src="./assets/Images/HomePage/ecc.png">
                                                                      </div>
                                                                      <div
                                                                            class="mask flex-center rgba-purple-slight">
                                                                      </div>
                                                                      <div class="card-footer">
                                                                            <h6
                                                                                  class="font-weight-light  wow fadeInUp text-white text-uppercase">
                                                                                  IS-UTILITIES</h6>
                                                                      </div>
                                                                </div>
                                                          </a>
                                                    </div>
                                                  
                                                    <div class="col-lg-2 col-md-4"></div>
                                                    <div class="col-lg-2 col-md-4"></div>
                                              </div>

                                        </div>
                                  </div>

                            </div>
                      </div>
                </div>
          </div>
          <div class="row justify-content-center mb-2 ">
        
            <p class="mod-singular-pager">
                  <a mdbPageScroll href="#aboutUs"  class="mod-singular-prev js-singular-prev scrollto z-depth-5 scrollarrow" 
                   mdbTooltip="Our Capability" placement="left"></a>
                  <a mdbPageScroll href="#standardDeployment" class="mod-singular-next js-singular-next scrollto z-depth-5 scrollarrow" 
                   mdbTooltip="Deployment Approach" placement="right"></a>
            </p>
        </div>
    </div>
</section><!-- End About Section -->